import { Injectable } from '@angular/core';
import { ApiServices } from '../shared/services/api.services';
import { ApiConstants } from '../shared/constants/api.constants';

@Injectable()
export class ResetPasswordService {
    private header = { 'Content-Type': 'application/json' };
    constructor(private apiService: ApiServices, private apiConstants: ApiConstants) {
    }

    resetPassword(params: Object) {
        return this.apiService.serviceCall(
            this.apiConstants.authUrl.resetUserPassword.url + '/api/v1/authn/credentials/reset_password',
            this.apiConstants.authUrl.resetUserPassword.method,
            params,
            null,
            this.header
        );
    }

    getStateToken(params: Object) {
        return this.apiService.serviceCall(
            this.apiConstants.authUrl.getStateToken.url + '/api/v1/authn/recovery/token',
            this.apiConstants.authUrl.getStateToken.method,
            params,
            null,
            this.header
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reset-password/reset-password.service.ts